import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CropsDashboardComponent} from './crops-dashboard/crops-dashboard.component';
import {CropsDetailsComponent} from './crops-details/crops-details.component';
import {MDBBootstrapModule} from 'angular-bootstrap-md';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {FormsModule} from '@angular/forms';



@NgModule({
  declarations: [
    CropsDashboardComponent,
    CropsDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MDBBootstrapModule,
    RouterModule,
    SharedModule,
    LazyLoadImageModule,
  ],
  exports: [
    CropsDashboardComponent,
    CropsDetailsComponent

  ]
})
export class CropsModule { }
